var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 11,
    viewBox: "0 0 11 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.1444 11L6.29444 7.15C5.98889 7.39444 5.6375 7.58796 5.24028 7.73056C4.84306 7.87315 4.42037 7.94444 3.97222 7.94444C2.86204 7.94444 1.92256 7.55985 1.15378 6.79067C0.385 6.02148 0.000407407 5.082 0 3.97222C0 2.86204 0.384593 1.92256 1.15378 1.15378C1.92296 0.385 2.86244 0.000407407 3.97222 0C5.08241 0 6.02189 0.384593 6.79067 1.15378C7.55944 1.92296 7.94404 2.86244 7.94444 3.97222C7.94444 4.42037 7.87315 4.84306 7.73056 5.24028C7.58796 5.6375 7.39444 5.98889 7.15 6.29444L11 10.1444L10.1444 11ZM3.97222 6.72222C4.73611 6.72222 5.38552 6.45476 5.92044 5.91983C6.45537 5.38491 6.72263 4.7357 6.72222 3.97222C6.72222 3.20833 6.45476 2.55893 5.91983 2.024C5.38491 1.48907 4.7357 1.22181 3.97222 1.22222C3.20833 1.22222 2.55893 1.48969 2.024 2.02461C1.48907 2.55954 1.22181 3.20874 1.22222 3.97222C1.22222 4.73611 1.48969 5.38552 2.02461 5.92044C2.55954 6.45537 3.20874 6.72263 3.97222 6.72222Z",
    fill: "#0152E9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/search-icon.ab41669be50ac2a1f3745fce7b2af60f.svg";
export { ForwardRef as ReactComponent };